const reducer = state => ({
  ...state,
  selectedBranch: null,
});

export default reducer;
